/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-children-prop */
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../assets/styles/pages/SignUp';
import Header from '../../../components/Header';

// import svg
import { ReactComponent as IconArrow } from '../../../assets/images/svg/sign_up/icon_seta_r.svg';
import { ReactComponent as IconEmail } from '../../../assets/images/svg/sign_up/icon_email.svg';
import { ReactComponent as IconPhone } from '../../../assets/images/svg/sign_up/icon_phone.svg';
import { ReactComponent as IconUser } from '../../../assets/images/svg/sign_up/icon_user.svg';
import { ReactComponent as IconInfo } from '../../../assets/images/svg/utils/info.svg';
import { ReactComponent as IconNoUser } from '../../../assets/images/svg/login/icon_no_user.svg';
import { ReactComponent as IconClose } from '../../../assets/images/svg/user/icon_fechar.svg';

import imgCpf from '../../../assets/images/cpf.png';

import FooterMenuMain from '../../../components/FooterMenuMain';
import { useSignInContext } from '../../../providers/use-signin';
import { useUserUpdateContext } from '../../../providers/use-user-update';
import ModalConfirmFooter from '../../../components/Modal/ConfirmFooter';
import { ItypeReturnApi } from '../../../helpers/utils/TypeReturnApi';
import { api } from '../../../services';
import {
  FormatCpf,
  onlyNumbers,
  validateCpf,
} from '../../../helpers/utils/Formating';
import { useLoadingContext } from '../../../providers/use-loading';

const styleModal = {
  position: 'absolute' as const,
  bottom: 0,
  width: '100%',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  p: '20px 20px 10px 20px',
  bgcolor: 'background.paper',
  outline: 'none',
};

const UserUpdate: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { signingOut, data, getDataUser } = useSignInContext();
  const navigate = useNavigate();
  const userUpdateContext = useUserUpdateContext();

  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [openModalRemoveAccount, setOpenModalRemoveAccount] = useState(false);
  const [errorInfo, setErrorInfo] = useState('');
  const [formParams, setFormParams] = useState({
    idUsuario: 0,
    dsNome: '',
    dsEmail: '',
    nrDDD: '',
    nrTelefone: '',
    dsCpf: '',
  });

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const logout = () => {
    signingOut();
    handleToPage('/');
  };

  const handleChangeForm = (event: any) => {
    const { name } = event.target;
    let { value } = event.target;

    if (name === 'dsCpf') {
      value = onlyNumbers(value);

      if (value.length > 11) {
        return;
      }
    }

    setFormParams((field) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });
  };

  const handleSubimt = async (event: SyntheticEvent) => {
    event.preventDefault();
    if (
      formParams.dsNome === '' ||
      formParams.dsEmail === '' ||
      formParams.nrDDD === '' ||
      formParams.nrTelefone === '' ||
      formParams.dsCpf === ''
    ) {
      setErrorInfo('Todas as informações são obrigatórias');
      setOpenUserNotParams(true);
      return;
    }

    if (formParams?.dsCpf) {
      if (!validateCpf(formParams.dsCpf)) {
        setErrorInfo('CPF inválido');
        setOpenUserNotParams(true);
        return;
      }
    }

    if (formParams.nrTelefone.length > 9 || formParams.nrDDD.length > 3) {
      setErrorInfo('Número de telefone inválido');
      setOpenUserNotParams(true);
      return;
    }

    await userUpdateContext.setDataUpdateStorage(formParams);

    handleToPage('/dashboard/user/update/email');
  };

  const handleRemoveAccount = async (): Promise<void> => {
    setOpenModalRemoveAccount(false);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.auth.removeAccount({
          nr_operacao: 56,
          idUsuario: data.user?.idUsuario,
        });

      if (result.data.retorno !== 'OK') {
        toast.error(
          'Ocorreu um erro ao tentar excluir a conta, por favor tente novamente mais tarde',
        );
      }
      toast.success(result.data.mensagem);
      logout();
    } catch (error) {
      toast.error(
        'Ocorreu um erro ao tentar excluir a conta, por favor tente novamente mais tarde',
      );
    }
  };

  const searchDataUser = async (): Promise<void> => {
    createloading(true);
    try {
      await getDataUser(data?.user?.idUsuario);
    } catch (error) {
      toast.error('Ocorreu um erro ao buscar os dados');
    } finally {
      createloading(false);
    }
  };

  const BtnRemoveAccount = () => {
    return (
      <Button
        onClick={() => setOpenModalRemoveAccount(true)}
        className={classeStyle.btn}
      >
        <p className={classeStyle.textMenu}>
          Apagar conta <IconClose className={classeStyle.iconMenuLeft} />
        </p>
      </Button>
    );
  };

  useEffect(() => {
    searchDataUser();
  }, []);

  useEffect(() => {
    setFormParams({
      idUsuario: data?.user?.idUsuario,
      dsNome: data?.user?.dsNome,
      dsEmail: data?.user?.dsEmail,
      nrDDD: data?.user?.nrDDD,
      nrTelefone: data?.user?.nrTelefone,
      dsCpf: data?.user?.dsCpf,
    });
  }, [data]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="updateUser" CtRight={BtnRemoveAccount} />

      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        {formParams.idUsuario > 0 && (
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            className={classeStyle.gridForm}
          >
            <h3>Editar conta</h3>
            <form onSubmit={handleSubimt} className={classeStyle.form}>
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                textAlign="center"
              >
                <label className={classeStyle.labelText}>Nome</label>
                <IconUser className={classeStyle.icon} />
                <input
                  type="text"
                  className={classeStyle.inputText}
                  placeholder="Digite seu nome completo"
                  value={formParams.dsNome}
                  name="dsNome"
                  onChange={handleChangeForm}
                />
              </Grid>

              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                textAlign="center"
              >
                <label className={classeStyle.labelText}>E-mail</label>
                <IconEmail className={classeStyle.icon} />
                <input
                  type="text"
                  className={classeStyle.inputText}
                  placeholder="exemplo@mail.com"
                  value={formParams.dsEmail}
                  name="dsEmail"
                  onChange={handleChangeForm}
                />
              </Grid>
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                textAlign="center"
              >
                <label className={classeStyle.labelText}>Telefone</label>
                <IconPhone className={classeStyle.icon} />
                <Grid container item>
                  <Grid item xs={4} marginLeft="0px">
                    <input
                      type="text"
                      className={classeStyle.inputText}
                      placeholder="DDD"
                      value={formParams.nrDDD}
                      name="nrDDD"
                      size={3}
                      maxLength={3}
                      onChange={handleChangeForm}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <input
                      type="text"
                      className={classeStyle.inputText}
                      placeholder="+ Telefone"
                      value={formParams.nrTelefone}
                      name="nrTelefone"
                      size={9}
                      maxLength={9}
                      onChange={handleChangeForm}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                textAlign="center"
              >
                <label className={classeStyle.labelText}>CPF</label>
                <img
                  className={classeStyle.icon}
                  style={{ width: 20, marginRight: 10 }}
                  src={imgCpf}
                  alt="icon"
                />
                <input
                  type="text"
                  className={classeStyle.inputText}
                  placeholder="CPF"
                  maxLength={14}
                  name="dsCpf"
                  value={FormatCpf(formParams.dsCpf)}
                  onChange={handleChangeForm}
                />
              </Grid>
              <Grid
                container
                item
                justifyContent="center"
                alignItems="center"
                textAlign="center"
              >
                <Button
                  className={classeStyle.btnSubmit}
                  type="submit"
                  variant="contained"
                >
                  Atualizar <IconArrow className={classeStyle.iconSave} />
                </Button>
              </Grid>
            </form>
          </Grid>
        )}
      </Grid>
      <FooterMenuMain />
      <Modal
        open={openUserNotParams}
        onClose={() => setOpenUserNotParams(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              Atenção!
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {errorInfo}
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnModal}
            onClick={() => setOpenUserNotParams(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
      <ModalConfirmFooter
        isOpen={openModalRemoveAccount}
        title="Atenção"
        message="Confirma apagar a conta? Esta ação não pode ser desfeita."
        btnNamePrimary="Confirmar"
        btnNameSecondary=""
        btnCancel="Voltar"
        handleFn={async () => handleRemoveAccount()}
        onClose={() => setOpenModalRemoveAccount(false)}
        icon={<IconNoUser className={classeStyle.iconModal} />}
        heightModal="500px"
      />
    </Container>
  );
};

export default UserUpdate;
